import * as Yup from "yup";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const createReminderElementFormValidationSchema = (t: TFunc) =>
	Yup.object().shape({
		title: Yup.string().required(t("validation:titleFieldRequired")),
		text: Yup.string().required(t("validation:textFieldRequired")),
	});
